/*global _ */
export const defaultFormFields = {}
export const allValidationsRules = {}
export default {defaultFormFields, allValidationsRules}
